import { fields } from './internal/fields';
import { marginSizes, paperSize } from './to-helpers';
export const to = (...opts) => {
    const options = {};
    let paper;
    let margins;
    for (let i = opts.length; i--;) {
        const op = opts[i];
        if (typeof op === 'function') {
            op(options);
            continue;
        }
        if (Array.isArray(op)) {
            if (op.length === 2)
                paper = op;
            if (op.length === 4)
                margins = op;
            continue;
        }
        if ('width' in op || 'height' in op) {
            paper = op;
            continue;
        }
        if ('top' in op || 'right' in op || 'bottom' in op || 'left' in op) {
            margins = op;
            continue;
        }
        if ('paper' in op && op.paper) {
            paper = op.paper;
            op.paper = undefined;
        }
        if ('margins' in op && op.margins) {
            margins = op.margins;
            op.margins = undefined;
        }
        Object.assign(options, op);
    }
    paper && paperSize(paper)(options);
    margins && marginSizes(margins)(options);
    return fields(options);
};
